/**
 * Android notification channels used by FCM payloads from Chatty / MM backends.
 * Channel sound/importance is immutable after first create — bump the id when
 * changing those properties (see chatty_messages_v2).
 */
export const FCM_ANDROID_CHANNELS = [
	{
		id: 'chatty_messages_v2',
		name: 'Chat messages',
		description: 'New chat messages',
		importance: 5 as const,
		sound: 'default',
		vibration: true,
		visibility: 1 as const,
	},
	{
		id: 'apexx_default',
		name: 'Notifications',
		description: 'General app notifications',
		importance: 5 as const,
		sound: 'default',
		vibration: true,
		visibility: 1 as const,
	},
] as const;

type PushNotificationsLike = {
	createChannel: (channel: {
		id: string;
		name: string;
		description?: string;
		importance?: 0 | 1 | 2 | 3 | 4 | 5;
		sound?: string;
		vibration?: boolean;
		visibility?: -1 | 0 | 1;
	}) => Promise<void>;
};

/**
 * Ensure FCM Android channels exist with sound enabled.
 * No-op on non-Android platforms.
 */
export async function ensureAndroidNotificationChannels(
	PushNotifications: PushNotificationsLike,
	platform: string,
): Promise<void> {
	if (platform !== 'android') {
		return;
	}

	for (const channel of FCM_ANDROID_CHANNELS) {
		await PushNotifications.createChannel({ ...channel });
	}
}
